import { TableImpostoGlobal } from "./Components/Table/TableGrupoImposto";

export const PageImpostos = () => {
  return <TableImpostoGlobal />;
};
